import React from "react";
import styled from "styled-components";
import Text from "../../../_components/Text";
import Button from "../../../_components/Button";
import WhatsAppButton from "./WhatsAppButton";
import { useShowMe } from "./hooks";
import { useHistory } from "react-router-dom";

const FooterContainer = styled.footer`
  width: 100%;
  padding: 1.5rem 2rem 2rem;
  background-color: #ffffff;
  border-top: 1px solid #dee2e6;
  box-shadow: 0 -1px 3px rgba(0, 0, 0, 0.05);
  font-size: 14px;
  color: #495057;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

const SocialContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;

  i {
    font-size: 24px;
    transition: transform 0.2s;
  }

  i:hover {
    transform: scale(1.1);
  }

  .instagram {
    color: #e1306c;
  }

  .youtube {
    color: #ff0000;
  }

  .facebook {
    color: #1877f2;
  }
`;

const FooterText = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  font-size: 13px;

  strong {
    color: #343a40;
  }

  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

export default () => {
  const handleShowMe = useShowMe();
  const history = useHistory();
  const [showState, setShowState] = React.useState({ showFooterText: true, showWhatsApp: true });

  React.useEffect(() => {
    const res = handleShowMe();
    if (typeof res === "boolean") {
      setShowState({ showFooterText: res, showWhatsApp: res });
    } else {
      setShowState(res);
    }
  }, [location.pathname, history]);

  const onClick = (href) => {
    window.open(href, "_blank");
  };

  if (!showState.showFooterText) {
    return showState.showWhatsApp ? <WhatsAppButton /> : null;
  }

  if (!showState.showWhatsApp && !showState.showFooterText) return null;

  return (
    <FooterContainer>
      <FooterText>
        <div>
          <Text>
            Copyright ©
            <img
              src="https://content.easygestor.com/easygestor/logo_easygestor.png"
              // alt="Easygestor logo"
              style={{ height: "16px", verticalAlign: "middle", margin: "0 4px" }}
            />
            — Powered By Easygestor 
          </Text>
        </div>
        <div>
          <Text>Versão {process.env.REACT_APP_BUILD_VERSION}</Text>
        </div>
      </FooterText>
      <SocialContainer>
        <Text>Nossas redes sociais :</Text>{" "}
        <Button
          as="text"
          title="Instagram"
          onClick={() =>
            onClick("https://www.instagram.com/otimizeseunegocio/")
          }
        >
          <i className="fab fa-instagram instagram" />
        </Button>
        <Button
          as="text"
          title="YouTube"
          onClick={() => onClick("https://www.youtube.com/@OtimizeSeuNegocio")}
        >
          <i className="fab fa-youtube youtube" />
        </Button>
        <Button
          as="text"
          title="Facebook"
          onClick={() => onClick("https://www.facebook.com/otimizeoseunegocio")}
        >
          <i className="fab fa-facebook-square facebook" />
        </Button>
      </SocialContainer>

      {showState.showWhatsApp && <WhatsAppButton />}
    </FooterContainer>
  );
};



// WEBPACK FOOTER //
// ./src/views/AppViews/Footer/index.jsx